<template>
    <div class="cargoinquiry">
        <div class="row justify-content-center">
            <div class="col-11 col-xl-6">
                <breadcrumbs :dom="crumbsItem" />
                <b-card no-body>
                    <b-tabs pills card :lazy="true">
                        <b-tab title="訂單查詢" active>
                            <OrderTab />
                        </b-tab>
                        <b-tab title="已取消之訂單">
                            <OrderTab :type="type" />
                        </b-tab>
                    </b-tabs>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
    import Breadcrumbs from '@/components/partial/Breadcrumbs'
    import OrderTab from '@/components/cargo/OrderTab'
    import userMixin from '@/mixins/user'

    export default {
        mixins: [userMixin],
        name: 'cargoinquiry',
        data() {
            return {
                crumbsItem: [{
                        text: '首頁',
                        to: '/',
                    },
                    {
                        text: '訂單查詢',
                        active: true
                    },
                ],
                type:2
            }
        },
        components: {
            Breadcrumbs,
            OrderTab,
        },
        methods: {
            initUser() {
                this.$router.push({ name: 'home' });
            },
        },
    }
</script>